// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d1ba24df","455":"fcc9c83c","644":"ab19cf70"}[chunkId] + ".chunk.js";
};